import axios from "../axios";
import { MultiPosGiftListV2Response } from "../../types";
import { AxiosReturn } from "../types";
import * as Requests from "../requests";

export const getMultiPosGiftGroupsApi = (
  token: string
): AxiosReturn<MultiPosGiftListV2Response> => {
  return axios.get(Requests.multiPosGiftGroupsURL, {
    headers: {
      token,
    },
  });
};
